import { CurdDataSetConfig, FormFieldType, Sensor } from '../types';
import { ChoiceTypes } from '@mri/enums';

export const sensorsDataSetConfig: CurdDataSetConfig<Sensor> = {
  entityName: 'Sensor',
  collectionName: 'Sensors',
  gatewayUrl: 'sensors',
  baseBreadcrumb: 'sensors',
  form: {
    listRedirectUrl: 'console/system/sensors/list',
    fields: [
      {
        key: 'key',
        label: 'Nombre de la llave',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-12'
      },
      {
        key: 'valueType',
        label: 'Tipo de valor',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-12',
        optionsConfigKey: ChoiceTypes.SENSOR_TYPE
      },
      {
        key: 'labelDefault',
        label: 'Etiqueta por defecto',
        type: FormFieldType.STRING,
        containerClass: 'col-md-4 col-sm-4',
        fillValue: (c) => (c.label || {})['default'] || ''
      },
      {
        key: 'labelEs',
        label: 'Etiqueta en español',
        type: FormFieldType.STRING,
        containerClass: 'col-md-4 col-sm-4',
        fillValue: (c) => (c?.label || {})['es'] || ''
      },
      {
        key: 'labelEn',
        label: 'Etiqueta en ingles',
        type: FormFieldType.STRING,
        containerClass: 'col-4 col-sm-4',
        fillValue: (c) => (c?.label || {})['en'] || ''
      },

      {
        key: 'valueLabel.true',
        label: 'Etiqueta de valor verdadero',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6',
        fillValue: (c) => (c?.valueLabel || {})['true'] || '',
        hide: ({values}) => values['valueType'] !== 'boolean'
      },
      {
        key: 'valueLabel.false',
        label: 'Etiqueta de valor falso',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6',
        fillValue: (c) => (c?.valueLabel || {})['false'] || '',
        hide: ({values}) => values['valueType'] !== 'boolean'
      },

      {
        key: 'image',
        image: (value) => value,
        label: 'Imagen URL',
        type: FormFieldType.STRING,
        containerClass: 'col-6 col-sm-6',
      },
      {
        key: 'icon',
        label: 'Clase del Icono',
        type: FormFieldType.STRING,
        containerClass: 'col-6 col-sm-6',
      },
      {
        key: 'description',
        label: 'Descripcion',
        type: FormFieldType.STRING,
        containerClass: 'col-12 col-sm-12',
        optionsGateway: 'sim-cards'
      },
      {
        key: 'isHoldValue',
        label: 'Sostener valor',
        type: FormFieldType.BOOLEAN,
        containerClass: 'col-12 col-sm-12',
      }
    ],
    handleObject: data => {
      const label = {
        default: data['labelDefault'],
        es: data['labelEs'],
        en: data['labelEn']
      };

      const valueLabel = {
        false: data['valueLabel.false'],
        true: data['valueLabel.true'],
      }

      return {
        ...data,
        label,
        valueLabel
      }
    }
  },
  list: {
    pageConfig: {
      title: 'Lista de sensores del sistema',
      breadcrumb: [
        {
          title: 'Sistema',
          type: 'item',
          link: '/console/system/sensors/list'
        },
        {
          title: 'Sensores',
          type: 'item',
          link: '/console/system/sensors/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/system/sensors/list',
          pageName: 'Sensores del sistema'
        }
      ]
    },
    filter: [
      {
        key: 'key',
        label: 'Valor',
        type: FormFieldType.STRING,
      },
      {
        key: 'valueType',
        label: 'Tipo de valor',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsConfigKey: ChoiceTypes.SENSOR_TYPE
      },
      {
        key: 'labelDefault',
        label: 'Etiqueta por defecto',
        type: FormFieldType.STRING,
      },

      {
        key: 'labelEs',
        label: 'Etiqueta en español',
        type: FormFieldType.STRING
      },

      {
        key: 'labelEn',
        label: 'Etiqueta en ingles',
        type: FormFieldType.STRING,
      },
    ],
    table: {
      columns: [
        {
          key: 'label', label: 'Nombre',
          getValue:  ({ element }) => element.label['es'] || element.label['default'] || 'No definido'
        },
        { key: 'key', label: 'Llave' },
        { key: 'description', label: 'Descripcion', },
        {  key: 'valueType', label: 'Tipo de valor'}
      ]
    },
    actionsKeys: ['create', 'edit', 'delete']
  },
  pages: ['list', 'edit', 'create']
};
